module.exports = __webpack_public_path__ + "static/media/15UN-Habitat8.7cd6ce73.jpg";